import React from 'react';
import { Table } from '../ui-kit';
import { StatusIndicator } from './ContractConstraintIndicator';

const statusLevelColors = {
  on_limit: 'orange',
  satisfied: 'green',
  unsatisfied: 'red'
};

const ContractConstraintTable = ({ constraintEvaluation }) => (
  <Table striped bordered condensed>
    <thead>
      <tr>
        <th>{I18n.t('attributes.name')}</th>
        <th>{I18n.t('attributes.description')}</th>
        <th className="number-column">
          {I18n.t('activerecord.attributes.reporting/contracts/contract_type_constraint.min')}
        </th>
        <th className="number-column">
          {I18n.t('activerecord.attributes.reporting/contracts/contract_type_constraint.max')}
        </th>
        <th className="number-column">
          {I18n.t('activerecord.attributes.reporting/contracts/contract_type_constraint.value')}
        </th>
        <th className="number-column">{I18n.t('activerecord.attributes.reporting/contracts/contract.balance')}</th>
        <th className="number-column">
          {I18n.t('activerecord.attributes.reporting/contracts/contract_type_constraint.time_unit')}
        </th>
      </tr>
    </thead>
    <tbody>
      {constraintEvaluation.map(constraint => (
        <tr key={constraint.id}>
          <th>{constraint.name}</th>
          <td>{constraint.description}</td>
          <td className="number-column">{constraint.formatted?.min}</td>
          <td className="number-column">{constraint.formatted?.max}</td>
          <td className="number-column" style={{ color: statusLevelColors[constraint.status] }}>
            <b>{constraint.formatted?.value}</b> <StatusIndicator status={constraint.status} />
          </td>
          <td className="number-column">{constraint.formatted?.remaining}</td>
          <td>{constraint.formatted?.time_unit}</td>
        </tr>
      ))}
    </tbody>
  </Table>
);

export default ContractConstraintTable;
